// import { Buttons } from '../Buttons';
import ThemeBtn from './ThemeBtn';

export {
    ThemeBtn
};
export default ThemeBtn;